var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivCI" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          !_vm.modalEsVerDetalle
                            ? (_vm.dialogConfirmacionClose = true)
                            : _vm.closeModal(false)
                        },
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.modalEsVerDetalle
                          ? "Ver Detalle"
                          : "Compartir Información"
                      )
                    )
                  ]),
                  _c("v-spacer"),
                  !_vm.modalEsVerDetalle
                    ? _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.e1 != 1,
                                  expression: "e1 != 1"
                                }
                              ],
                              staticClass: "btn-volver",
                              attrs: { disabled: _vm.e1 <= 1 },
                              on: {
                                click: function($event) {
                                  _vm.volver(), _vm.cierraMenu()
                                }
                              }
                            },
                            [_vm._v("Volver")]
                          ),
                          _vm._v("  \n          "),
                          _c(
                            "v-btn",
                            {
                              class: _vm.btnClass,
                              attrs: {
                                disabled: !_vm.validForm || _vm.btnBloquear
                              },
                              on: {
                                click: function($event) {
                                  _vm.continuar(), _vm.cierraMenu()
                                }
                              }
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.btnText))])]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              !_vm.modalEsVerDetalle
                ? _c(
                    "v-stepper",
                    {
                      model: {
                        value: _vm.e1,
                        callback: function($$v) {
                          _vm.e1 = $$v
                        },
                        expression: "e1"
                      }
                    },
                    [
                      _c(
                        "v-stepper-header",
                        [
                          _c(
                            "v-stepper-step",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cliente.visible,
                                  expression: "cliente.visible"
                                }
                              ],
                              attrs: {
                                complete: _vm.e1 > _vm.cliente.step,
                                step: _vm.cliente.step
                              }
                            },
                            [_vm._v("Cliente")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.informacionCompartir.visible,
                                  expression: "informacionCompartir.visible"
                                }
                              ],
                              attrs: {
                                complete:
                                  _vm.e1 > _vm.informacionCompartir.step,
                                step: _vm.informacionCompartir.step
                              }
                            },
                            [_vm._v("Compartir Información")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-items",
                        { staticClass: "cardnew" },
                        [
                          _c(
                            "v-stepper-content",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.informacionCompartir.visible,
                                  expression: "informacionCompartir.visible"
                                }
                              ],
                              attrs: { step: _vm.informacionCompartir.step }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { align: "center" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md10: "" } },
                                    [
                                      _c(
                                        "v-card",
                                        { staticClass: "rounded-card" },
                                        [
                                          _c(
                                            "v-form",
                                            {
                                              ref: "form",
                                              staticClass: "col-md-12",
                                              attrs: { "lazy-validation": "" },
                                              model: {
                                                value: _vm.validForm,
                                                callback: function($$v) {
                                                  _vm.validForm = $$v
                                                },
                                                expression: "validForm"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-container",
                                                {
                                                  attrs: {
                                                    "grid-list-md": "",
                                                    "text-xs-center": ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            align: "left"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                md12: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "h2",
                                                                {
                                                                  staticClass:
                                                                    "h2_title"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Compartir Información"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  ),
                                                  _c("v-divider"),
                                                  _c(
                                                    "v-layout",
                                                    { attrs: { wrap: "" } },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "estilo-radio",
                                                          attrs: {
                                                            xs12: "",
                                                            md12: "",
                                                            lg12: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-radio-group",
                                                            {
                                                              attrs: {
                                                                row: ""
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.changeTipo
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.radios,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.radios = $$v
                                                                },
                                                                expression:
                                                                  "radios"
                                                              }
                                                            },
                                                            [
                                                              _c("v-radio", {
                                                                attrs: {
                                                                  label:
                                                                    "Flotas",
                                                                  value:
                                                                    "Flotas"
                                                                }
                                                              }),
                                                              _c("v-radio", {
                                                                attrs: {
                                                                  label:
                                                                    "Vehículos",
                                                                  value:
                                                                    "Vehículos"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.tipoCompartirInformacion ===
                                                            1,
                                                          expression:
                                                            "tipoCompartirInformacion === 1"
                                                        }
                                                      ]
                                                    },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "estilo-buscar",
                                                              attrs: { md6: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      "Buscar...",
                                                                    "prepend-icon":
                                                                      "commute",
                                                                    "append-icon":
                                                                      "search"
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.onFilterTextBoxChangedFlotas
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.buscarFlotas,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.buscarFlotas = $$v
                                                                    },
                                                                    expression:
                                                                      "buscarFlotas"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c("br"),
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                md12: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-card",
                                                                [
                                                                  _c(
                                                                    "ag-grid-vue",
                                                                    {
                                                                      staticClass:
                                                                        "ag-theme-material",
                                                                      staticStyle: {
                                                                        width:
                                                                          "100%",
                                                                        height:
                                                                          "380px",
                                                                        "font-family":
                                                                          "'Asap', sans-serif"
                                                                      },
                                                                      attrs: {
                                                                        columnDefs:
                                                                          _vm.columnDefsFlotas,
                                                                        rowData:
                                                                          _vm.flotasRespaldo,
                                                                        rowSelection:
                                                                          "single",
                                                                        rowMultiSelectWithClick:
                                                                          "false",
                                                                        pagination:
                                                                          "true",
                                                                        paginationPageSize:
                                                                          "10",
                                                                        suppressRowClickSelection:
                                                                          "true",
                                                                        sideBar:
                                                                          _vm.sideBar,
                                                                        localeText:
                                                                          _vm.localeText,
                                                                        onGridReady:
                                                                          _vm.onGridReadyFlotas,
                                                                        postProcessPopup:
                                                                          _vm.onClickCell,
                                                                        getRowNodeId:
                                                                          _vm.getRowNodeIdFlota,
                                                                        suppressCopyRowsToClipboard:
                                                                          "true",
                                                                        suppressCsvExport: true,
                                                                        suppressExcelExport: true,
                                                                        suppressNoRowsOverlay: true,
                                                                        isExternalFilterPresent:
                                                                          _vm.isExternalFilterPresentFlota,
                                                                        doesExternalFilterPass:
                                                                          _vm.doesExternalFilterPassFlota
                                                                      },
                                                                      on: {
                                                                        "selection-changed": function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.onSelectedChangeFlota()
                                                                        }
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.tipoCompartirInformacion ===
                                                            2,
                                                          expression:
                                                            "tipoCompartirInformacion === 2"
                                                        }
                                                      ]
                                                    },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "estilo-buscar",
                                                              attrs: { md6: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "v-autocomplete",
                                                                {
                                                                  attrs: {
                                                                    "prepend-icon":
                                                                      "label",
                                                                    items:
                                                                      _vm.etiquetasRespaldo,
                                                                    color:
                                                                      "primary",
                                                                    clearable: true,
                                                                    "item-text":
                                                                      "nombre",
                                                                    chips: "",
                                                                    "deletable-chips": true,
                                                                    "item-value":
                                                                      "id",
                                                                    label:
                                                                      "Etiquetas",
                                                                    "no-data-text":
                                                                      "Sin resultados",
                                                                    multiple: ""
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      _vm.onEtiquetaChange
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "selection",
                                                                        fn: function(
                                                                          ref
                                                                        ) {
                                                                          var item =
                                                                            ref.item
                                                                          var index =
                                                                            ref.index
                                                                          return [
                                                                            index ===
                                                                            0
                                                                              ? _c(
                                                                                  "v-chip",
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.textoComprimido(
                                                                                              item.nombre
                                                                                            )
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            index ===
                                                                            1
                                                                              ? _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "grey--text caption"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "(+" +
                                                                                        _vm._s(
                                                                                          _vm
                                                                                            .etiquetasAsignados
                                                                                            .length -
                                                                                            1
                                                                                        ) +
                                                                                        "\n                                  otros)"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e()
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    false,
                                                                    3018338580
                                                                  ),
                                                                  model: {
                                                                    value:
                                                                      _vm.etiquetasAsignados,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.etiquetasAsignados = $$v
                                                                    },
                                                                    expression:
                                                                      "etiquetasAsignados"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "estilo-buscar2",
                                                              attrs: { md6: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      "Buscar...",
                                                                    "prepend-icon":
                                                                      "directions_car",
                                                                    "append-icon":
                                                                      "search"
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.onFilterTextBoxChangedVehiculos
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.buscarVehiculos,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.buscarVehiculos = $$v
                                                                    },
                                                                    expression:
                                                                      "buscarVehiculos"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c("br"),
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                md12: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-card",
                                                                [
                                                                  _c(
                                                                    "ag-grid-vue",
                                                                    {
                                                                      staticClass:
                                                                        "ag-theme-material",
                                                                      staticStyle: {
                                                                        width:
                                                                          "100%",
                                                                        height:
                                                                          "380px",
                                                                        "font-family":
                                                                          "'Asap', sans-serif"
                                                                      },
                                                                      attrs: {
                                                                        columnDefs:
                                                                          _vm.columnDefsVehiculosCompartir,
                                                                        rowData:
                                                                          _vm.vehiculosRespaldo,
                                                                        rowSelection:
                                                                          "multiple",
                                                                        rowMultiSelectWithClick:
                                                                          "false",
                                                                        pagination:
                                                                          "true",
                                                                        paginationPageSize:
                                                                          "10",
                                                                        suppressRowClickSelection:
                                                                          "true",
                                                                        sideBar:
                                                                          _vm.sideBar,
                                                                        localeText:
                                                                          _vm.localeText,
                                                                        onGridReady:
                                                                          _vm.onGridReadyVehiculosCompartir,
                                                                        postProcessPopup:
                                                                          _vm.onClickCell,
                                                                        suppressCsvExport: true,
                                                                        suppressExcelExport: true,
                                                                        getRowNodeId:
                                                                          _vm.getRowNodeIdVehiculo,
                                                                        suppressCopyRowsToClipboard:
                                                                          "true",
                                                                        suppressNoRowsOverlay: true,
                                                                        isExternalFilterPresent:
                                                                          _vm.isExternalFilterPresent,
                                                                        doesExternalFilterPass:
                                                                          _vm.doesExternalFilterPass
                                                                      },
                                                                      on: {
                                                                        "selection-changed": function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.onSelectedChangeVehiculos()
                                                                        }
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "v-stepper-content",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cliente.visible,
                                  expression: "cliente.visible"
                                }
                              ],
                              attrs: { step: _vm.cliente.step }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { align: "center" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md10: "" } },
                                    [
                                      _c(
                                        "v-card",
                                        { staticClass: "rounded-card" },
                                        [
                                          _c("v-form", {
                                            ref: "form2",
                                            staticClass: "col-md-12",
                                            attrs: { "lazy-validation": "" },
                                            model: {
                                              value: _vm.validForm2,
                                              callback: function($$v) {
                                                _vm.validForm2 = $$v
                                              },
                                              expression: "validForm2"
                                            }
                                          }),
                                          _c(
                                            "v-container",
                                            {
                                              attrs: {
                                                "grid-list-md": "",
                                                "text-xs-center": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: { align: "left" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { md12: "" } },
                                                        [
                                                          _c(
                                                            "h2",
                                                            {
                                                              staticClass:
                                                                "h2_title"
                                                            },
                                                            [_vm._v("Cliente")]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _c("v-divider"),
                                              _c("br"),
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "estilo-buscar",
                                                      attrs: { md6: "" }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "Buscar...",
                                                          "prepend-icon":
                                                            "person",
                                                          "append-icon":
                                                            "search"
                                                        },
                                                        on: {
                                                          input:
                                                            _vm.onFilterTextBoxChangedCliente
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.buscarClientes,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.buscarClientes = $$v
                                                          },
                                                          expression:
                                                            "buscarClientes"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("br"),
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { md12: "" } },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        [
                                                          _c("ag-grid-vue", {
                                                            staticClass:
                                                              "ag-theme-material",
                                                            staticStyle: {
                                                              width: "100%",
                                                              height: "380px",
                                                              "font-family":
                                                                "'Asap', sans-serif"
                                                            },
                                                            attrs: {
                                                              columnDefs:
                                                                _vm.columnDefsClientes,
                                                              rowData:
                                                                _vm.clientesRespaldo,
                                                              rowSelection:
                                                                "single",
                                                              rowMultiSelectWithClick:
                                                                "false",
                                                              pagination:
                                                                "true",
                                                              paginationPageSize:
                                                                "10",
                                                              suppressRowClickSelection:
                                                                "true",
                                                              sideBar:
                                                                _vm.sideBar,
                                                              localeText:
                                                                _vm.localeText,
                                                              onGridReady:
                                                                _vm.onGridReadyClientes,
                                                              postProcessPopup:
                                                                _vm.onClickCell,
                                                              getRowNodeId:
                                                                _vm.getRowNodeIdCliente,
                                                              suppressCopyRowsToClipboard:
                                                                "true",
                                                              suppressCsvExport: true,
                                                              suppressExcelExport: true,
                                                              suppressNoRowsOverlay: true,
                                                              isExternalFilterPresent:
                                                                _vm.isExternalFilterPresentCliente,
                                                              doesExternalFilterPass:
                                                                _vm.doesExternalFilterPassCliente
                                                            },
                                                            on: {
                                                              "selection-changed": function(
                                                                $event
                                                              ) {
                                                                return _vm.onSelectedChangeCliente()
                                                              }
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.modalEsVerDetalle
                ? _c(
                    "div",
                    [
                      _c(
                        "v-card",
                        { attrs: { height: "55px", flat: "" } },
                        [
                          _c(
                            "v-bottom-nav",
                            {
                              attrs: {
                                active: _vm.bottomNav,
                                value: true,
                                absolute: "",
                                color: "transparent"
                              },
                              on: {
                                "update:active": function($event) {
                                  _vm.bottomNav = $event
                                }
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    flat: "",
                                    value: "1"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Información")]),
                                  _c("v-icon", [_vm._v("info")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.bottomNav == "1",
                              expression: "bottomNav == '1'"
                            }
                          ],
                          staticClass: "cardnew",
                          attrs: { align: "center" }
                        },
                        [
                          _c("br"),
                          _c(
                            "div",
                            { attrs: { align: "center" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md10: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "rounded-card" },
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "form",
                                          staticClass: "col-md-12",
                                          attrs: { "lazy-validation": "" },
                                          model: {
                                            value: _vm.validForm,
                                            callback: function($$v) {
                                              _vm.validForm = $$v
                                            },
                                            expression: "validForm"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-container",
                                            {
                                              attrs: {
                                                "grid-list-md": "",
                                                "text-xs-center": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: { align: "left" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { md12: "" } },
                                                        [
                                                          _c(
                                                            "h2",
                                                            {
                                                              staticClass:
                                                                "h2_title"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Información"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _c("v-divider"),
                                              _c("br"),
                                              _c(
                                                "div",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c("br"),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { md12: "" } },
                                                        [
                                                          _c(
                                                            "v-card",
                                                            [
                                                              _c(
                                                                "ag-grid-vue",
                                                                {
                                                                  staticClass:
                                                                    "ag-theme-material",
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%",
                                                                    height:
                                                                      "380px",
                                                                    "font-family":
                                                                      "'Asap', sans-serif"
                                                                  },
                                                                  attrs: {
                                                                    columnDefs:
                                                                      _vm.columnDefsVerDetalle,
                                                                    rowData:
                                                                      _vm.vehiculosVerDetalle,
                                                                    rowSelection:
                                                                      "multiple",
                                                                    rowMultiSelectWithClick:
                                                                      "false",
                                                                    pagination:
                                                                      "true",
                                                                    paginationPageSize:
                                                                      "10",
                                                                    suppressRowClickSelection:
                                                                      "true",
                                                                    sideBar:
                                                                      _vm.sideBar,
                                                                    localeText:
                                                                      _vm.localeText,
                                                                    onGridReady:
                                                                      _vm.onGridReadyVehiculosDetalle,
                                                                    postProcessPopup:
                                                                      _vm.onClickCell,
                                                                    suppressCsvExport: true,
                                                                    suppressExcelExport: true
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm.motivoRechazo !== ""
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                md12: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    md12: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-textarea",
                                                                    {
                                                                      attrs: {
                                                                        name:
                                                                          "input-7-1",
                                                                        label:
                                                                          _vm.estadorechazo,
                                                                        value:
                                                                          _vm.motivoRechazo,
                                                                        readonly:
                                                                          "",
                                                                        box: "",
                                                                        rows: 3,
                                                                        hint:
                                                                          "Usuario: " +
                                                                          _vm.usuarioModificador,
                                                                        "persistent-hint":
                                                                          ""
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.compartirInformacion.titulo"),
          mensaje: _vm.$t("mensajes.crud.compartirInformacion.mensaje", {
            nombre_cliente: _vm.nombreCliente
          }),
          textoBtnSi: _vm.$t("mensajes.crud.compartirInformacion.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.compartirInformacion.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.crear.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.crear.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": 400 },
              model: {
                value: _vm.showAlertaSinEntidad,
                callback: function($$v) {
                  _vm.showAlertaSinEntidad = $$v
                },
                expression: "showAlertaSinEntidad"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "17px",
                            "margin-left": "10px !important"
                          }
                        },
                        [_vm._v("Compartir Flota o Vehículos")]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("v-card-text", [
                    _vm._v(
                      "No existe información disponible para compartir con el Cliente\n          seleccionado"
                    )
                  ]),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "#526da5", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.confirmCallbackSinEntidad()
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v("Aceptar")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": 400 },
              model: {
                value: _vm.showAlertaCliente,
                callback: function($$v) {
                  _vm.showAlertaCliente = $$v
                },
                expression: "showAlertaCliente"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "17px",
                            "margin-left": "10px !important"
                          }
                        },
                        [_vm._v("Seleccionar Cliente")]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("v-card-text", [_vm._v("Debe seleccionar un Cliente")]),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "#526da5", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.confirmCallbackCliente()
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v("Aceptar")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": 400 },
              model: {
                value: _vm.showAlertaEntidad,
                callback: function($$v) {
                  _vm.showAlertaEntidad = $$v
                },
                expression: "showAlertaEntidad"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "17px",
                            "margin-left": "10px !important"
                          }
                        },
                        [_vm._v("Seleccionar Flota o Vehículos")]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("v-card-text", [
                    _vm._v("Debe seleccionar una Flota o Vehículos")
                  ]),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "#526da5", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.confirmCallbackEntidad()
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v("Aceptar")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": 400 },
              model: {
                value: _vm.showAlertaChangeTipo,
                callback: function($$v) {
                  _vm.showAlertaChangeTipo = $$v
                },
                expression: "showAlertaChangeTipo"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "17px",
                            "margin-left": "10px !important"
                          }
                        },
                        [_vm._v("Compartir Información")]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("v-card-text", [
                    _vm._v(
                      "Al cambiar la selección toda la información se perderá. ¿Está\n          seguro que desea continuar?"
                    )
                  ]),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "white", depressed: "", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.closeChangeTipo()
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "#526da5" } }, [
                            _vm._v("Cancelar")
                          ])
                        ]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "#526da5", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.confirmCallbackChangeTipo()
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v("Continuar")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }